import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { GenericService } from 'src/app/services/generic.service';

@Component({
  selector: 'app-delete-product-category',
  templateUrl: './delete-product-category.component.html',
  styleUrls: ['./delete-product-category.component.css']
})
export class DeleteProductCategoryComponent implements OnInit {

  productCategoryList: any= []
  page: number = 1;
  count: number = 0;
  tableSize: number = 10;
  tableSizes: any = [3, 6, 9, 12];
  singleProductCategoryData: any= []
  deleteProductCategoryId:any = [];

  constructor(private toastr: ToastrService,private generic_service: GenericService) { }

  ngOnInit(): void {
    this.getAllProductCategory();
  }

  onTableDataChange(event: any) {
    this.page = event;
    this.getAllProductCategory();
  }

  getAllProductCategory(){
    this.generic_service.getAllProductCategory().subscribe(
      (response:any)=>{
        console.log(response);
        this.productCategoryList = response.response
      }
    )
  }

  getProductCategoryById(productCategoryId:any){
    this.generic_service.getProductCategoryById(productCategoryId).subscribe(
      (res:any)=>{
        console.log(res)
        this.singleProductCategoryData = []
        this.singleProductCategoryData.push(res.response)
      },
      (err:any)=> {
        console.log(err)
      }
    )
  }

  cancelModel(){
    document.getElementById("closeModalButton")?.click()
    document.getElementById("closeModalButton1")?.click()
  }

  selectProductCategory(id:any){
    this.deleteProductCategoryId = id
  }

  deleteProductCategory(){
    this.generic_service.deleteProductCategory(this.deleteProductCategoryId).subscribe(
      (res:any)=>{
        console.log(res)
        this.getAllProductCategory()
        this.toastr.success("Successfully Deleted")
        this.cancelModel()
      },
      (err:any)=> {
        console.log(err)
        this.toastr.error(err.errors[0].description)
      }
    )
  }

}

